module.exports = "https://cdn.littlereply.com/tt/resource/tab5_icon_help.5d3788f9cf70388c127534d7a7349032.png";